import type ModalConversationService from '../../conversation/modal-conversation.service';
import type {Record, StaticSearchParams} from 'typings/portaro.be.types';
import type {
    SearchSelectionModalModel
} from '../../conversation/search-selection-modal/search-selection-modal.component';

export default class SearchableValueEditorService {
    public static readonly serviceName = 'searchableValueEditorService';

    /*@ngInject*/
    constructor(private modalConversationService: ModalConversationService) {
    }

    public async searchAndSelectItem($additionalParameters: StaticSearchParams, customTemplateUrl?: string): Promise<Record> {
        const modalModel: SearchSelectionModalModel = {
            staticSearchParams: $additionalParameters,
            customTemplateUrl
        };
        return this.modalConversationService.searchItem<Record>(modalModel);
    }
}